/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../../app/payments/payment-success.component';
import * as import3 from '../../../app/services/local-storage.service';
import * as import4 from '@angular/router';
const styles_PaymentSuccessComponent:any[] = ([] as any[]);
export const RenderType_PaymentSuccessComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PaymentSuccessComponent,
  data: {}
}
);
function View_PaymentSuccessComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'style',
        'text-align:center; margin: 0 auto; width:margin-top:60px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n  '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dziękujemy'])),
    (l()(),import0.ɵted((null as any),['\n  '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Twoje zamówienie zostało opłacone, usługi zostaną uruchomione najszybciej jak to możliwe. W razie pytań zapraszamy do kontaktu z BOK (sekcja wiadomości).'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
export function View_PaymentSuccessComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaymentSuccessComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import2.PaymentSuccessComponent = v.component;
    const currVal_0:boolean = !co.loading;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_PaymentSuccessComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'payment-success',([] as any[]),(null as any),(null as any),(null as any),View_PaymentSuccessComponent_0,RenderType_PaymentSuccessComponent)),
    import0.ɵdid(114688,(null as any),0,import2.PaymentSuccessComponent,[
      import3.LocalStorageService,
      import4.ActivatedRoute,
      import4.Router
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PaymentSuccessComponentNgFactory:import0.ComponentFactory<import2.PaymentSuccessComponent> = import0.ɵccf('payment-success',import2.PaymentSuccessComponent,View_PaymentSuccessComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYXltZW50cy9wYXltZW50LXN1Y2Nlc3MuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYXltZW50cy9wYXltZW50LXN1Y2Nlc3MuY29tcG9uZW50LnRzIiwibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9zcmMvYXBwL3BheW1lbnRzL3BheW1lbnQtc3VjY2Vzcy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYXltZW50cy9wYXltZW50LXN1Y2Nlc3MuY29tcG9uZW50LnRzLlBheW1lbnRTdWNjZXNzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBzdHlsZT1cInRleHQtYWxpZ246Y2VudGVyOyBtYXJnaW46IDAgYXV0bzsgd2lkdGg6bWFyZ2luLXRvcDo2MHB4O1wiICpuZ0lmPVwiIWxvYWRpbmdcIj5cbiAgPGgyPkR6acSZa3VqZW15PC9oMj5cbiAgPHA+VHdvamUgemFtw7N3aWVuaWUgem9zdGHFgm8gb3DFgmFjb25lLCB1c8WCdWdpIHpvc3RhbsSFIHVydWNob21pb25lIG5hanN6eWJjaWVqIGphayB0byBtb8W8bGl3ZS4gVyByYXppZSBweXRhxYQgemFwcmFzemFteSBkbyBrb250YWt0dSB6IEJPSyAoc2VrY2phIHdpYWRvbW/Fm2NpKS48L3A+XG48L2Rpdj4iLCI8cGF5bWVudC1zdWNjZXNzPjwvcGF5bWVudC1zdWNjZXNzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdGO0lBQ3RGO0lBQUk7SUFBZTtJQUNuQjtJQUFHO0lBQTZKOzs7Ozs7SUFGbEs7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUF1RTtJQUF2RSxTQUF1RSxTQUF2RTs7Ozs7SUNBQTtnQkFBQTs7OztJQUFBO0tBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/payments/payment-success.component.ngfactory.ts